import { AllowedDocumentContentType, BusinessType } from '../../api/tvs/uploadSessions/model/UploadSession';

export const ACCEPTED_DOCUMENT_FILE_EXTENSIONS = ['.pdf', '.jpg', '.jpeg', '.png', '.webp'] as const;

export const ACCEPTED_DOCUMENT_FILE_TYPES = ACCEPTED_DOCUMENT_FILE_EXTENSIONS.join(',');

export const ALLOWED_DOCUMENT_CONTENT_TYPES = ['application/pdf', 'image/png', 'image/jpeg', 'image/webp'] as const;

export const MAX_DOCUMENT_FILE_SIZE_MB = 10;

export const MAX_DOCUMENT_FILE_SIZE_BYTES = MAX_DOCUMENT_FILE_SIZE_MB * 1024 * 1024;

const ID_CARD_ONLY_BUSINESS_TYPES = ['NO_REGISTER_ENTRY', 'UNSPECIFIED'] as const satisfies BusinessType[];

export const requiresBusinessLicense = (businessType: BusinessType): boolean => {
  return !(ID_CARD_ONLY_BUSINESS_TYPES as readonly BusinessType[]).includes(businessType);
};

export const getDocumentContentType = (file: File): AllowedDocumentContentType | undefined => {
  if (ALLOWED_DOCUMENT_CONTENT_TYPES.includes(file.type as AllowedDocumentContentType)) {
    return file.type as AllowedDocumentContentType;
  }

  const fileName = file.name.toLowerCase();

  if (fileName.endsWith('.pdf')) return 'application/pdf';
  if (fileName.endsWith('.png')) return 'image/png';
  if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg')) return 'image/jpeg';
  if (fileName.endsWith('.webp')) return 'image/webp';

  return undefined;
};
